<template>
  <b-form-group>
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text>
          <i class="fas fa-calendar-alt"></i>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="date" v-model="filterDate"></b-form-input>

      <b-input-group-prepend>
        <b-input-group-text>
          <i class="fas fa-clock"></i>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="number" v-model="days" placeholder="일 수"></b-form-input>

      <b-input-group-append>
        <b-button @click="applyFilter" variant="primary">
          <i class="fas fa-search"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({ date: '', days: '' })
    }
  },
  data() {
    return {
      filterDate: this.value.date,
      days: this.value.days
    };
  },
  methods: {
    applyFilter() {
      const utcDate = this.localToUTC(this.filterDate);
      this.$emit('input', { date: utcDate, days: this.days });
    },
    localToUTC(localTime) {
      const localDate = new Date(localTime);
      const year = localDate.getUTCFullYear();
      const month = String(localDate.getUTCMonth() + 1).padStart(2, '0');
      const day = String(localDate.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  },
  watch: {
    value: {
      handler(val) {
        this.filterDate = val.date;
        this.days = val.days;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.b-input-group-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
.b-button {
  display: flex;
  align-items: center;
}
</style>
